import React, { useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCreditCard,
  faFile,
  faPersonChalkboard,
} from "@fortawesome/free-solid-svg-icons";
import banner from "../../images/banner-logo.webp";
import logo from "../../images/city-logo.png";
// import onlinePayment from "../../images/online-payment.png";
// import requestBilling from "../../images/request-billing.png";

const Header = (props) => {
  const navigate = useNavigate();

  const isEnabled = (module) => {
    const config = this.state.modules.filter((_) => _.type === module);
    if (config.length > 0) {
      return config[0].enabled;
    }
    return false;
  };

  return (
    <>
      <header className="w-screen h-18 border bg-green-800 fixed top-0 left-0 p-2 flex gap-2">
        <img src={logo} alt="Logo" className="h-20" />
        <div className="hidden pt-3 md:block lg:block xl:block 2xl:block">
          <div className="text-sm text-gray-200 text-center  ">
            City Treasurer's Office
          </div>
          <div className="text-lg text-white font-bold">
            Online Payment Portal
          </div>
        </div>
        <div className="flex-grow flex gap-4 pt-5 pl-10">
          <a
            href=""
            className="text-white hover:font-bold flex"
            onClick={() => navigate("/payment")}
          >
            <FontAwesomeIcon icon={faCreditCard} className="h-5 mr-2" />
            Payment
          </a>
          <a
            href=""
            className="text-white hover:font-bold flex"
            onClick={() => navigate("/request-billing")}
          >
            <FontAwesomeIcon icon={faFile} className="h-5 mr-2" />
            Request Billing
          </a>
          <div className="flex-grow text-right">
            <a
              href=""
              className="text-white hover:font-bold flex"
              onClick={() => navigate("/request-billing")}
            >
              <FontAwesomeIcon icon={faPersonChalkboard} className="h-5 mr-2" />
              Instructions
            </a>
          </div>
        </div>
      </header>

      {/* <Navbar
        collapseOnSelect
        expand="lg"
        bg="light"
        variant="light"
        className="fixed-top page-header"
      >
        <Navbar.Brand
          href="https://citytreasury.paranaque.ph/home"
          className="nav-logo"
        >
          <img src={banner} alt="city-logo" className="banner-logo" />
          <img src={logo} alt="city-logo" className="city-logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" bg="light" />
        <Navbar.Collapse id="responsive-navbar-nav" bg="light">
          <Nav>
            <Nav.Item>
              <Link to="/home" className="nav-link">
                <i className="fas fa-home"></i> Home
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link to="/cedula" className="nav-link">
                <i className="fas fa-file"></i> Cedula
              </Link>
            </Nav.Item>

            <Nav.Item>
              <Link to="/payment" className="nav-link">
                <i
                  className="fas fa-credit-card"
                  style={{ marginRight: 5 }}
                ></i>
                Online Payment
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link to="/request-billing" className="nav-link">
                <i
                  className="fas fa-file-invoice"
                  style={{ marginRight: 5 }}
                ></i>
                Request Online Billing
              </Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Navbar> */}
    </>
  );
};

export default Header;
